import { Box } from '@mui/material';
import React, {ReactNode, useEffect, useRef} from 'react';
import PerfectScrollbar from 'react-perfect-scrollbar';
import {useLocation} from 'react-router-dom';

interface ScrollbarProps {
  children: ReactNode;
  className?: string;
  scrollToTop?: boolean;

  [x: string]: any;
}

export const excludedScrollbarUrls = [
  "/CupBooking",
  "/modificaPrenotazione",
  "/prenotaListaAttesa",
].map((item) => item.toLowerCase());

const Scrollbar: React.FC<ScrollbarProps> = React.forwardRef((props, ref) => {
  const {children, scrollToTop = true, className = '', ...others} = props;
  let _scrollBarRef = useRef<PerfectScrollbar>(null);
  const {pathname} = useLocation();

  useEffect(() => {
    const AA_scrollBarRef = _scrollBarRef.current;
    if (scrollToTop && AA_scrollBarRef) {
      // @ts-ignore
      AA_scrollBarRef._container.scrollTop = 0;
    }
  }, [_scrollBarRef, pathname, scrollToTop]);

  return (
    excludedScrollbarUrls.includes(pathname.toLowerCase()) ? <Box
      display='flex' flexDirection='column' height='100%'
      className={`scrollbar-container ${className}`}
      {...others}
    >
      {children}
    </Box>
    :
    <PerfectScrollbar
      ref={_scrollBarRef}
      {...others}
      className={className}>
      {children}
    </PerfectScrollbar>
  );
});

export default Scrollbar;
